module.exports = __webpack_public_path__ + "static/media/scale2.2ef47b71.png";